<template>
  <div>
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/outsource/outsource1.jpg);height:713px"
      >
        <div class="content">
          <div class="container">
            <div
              class="font-color-1 font-size-76 text-align-center"
              style="padding-top:250px;padding-bottom:70px;"
            >精准聚焦，携手共赢</div>
            <div class="text-align-center">
              <span class="register-btn">业务精湛 / 资金保障 / 合同规范</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于金创客 -->
    <div>
      <div class="content">
        <div class="container text-align-center">
          <div class="title font-color-2">关于金创客</div>
          <div class="sub-title">ABOUT US</div>
          <div style="margin-bottom:20px;">
            <span class="slider slider-orange"></span>
          </div>
          <p
            class="content font-size-18"
            style="line-height:32px;"
          >金创客相较于创客而言，利用自己的专业技能有更高的创收能力。针对年收入较高、能够持续创造收入的个人，注册成立个人工作室，企业与金创客直接进行业务合作、资金结算、发票开具等，平台提供商事登记、银行开户、税务申报、代理记账、代开发票等一站式财税服务，可享受园区核定征收的政策。</p>
          <img
            src="https://file.lgbfss.com/www/official/images/outsource/outsource2.png"
            alt
            class="image-center"
            style="width:1206px;"
          />
        </div>
      </div>
    </div>
    <!-- 金创客优势 -->
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/outsource/outsource3.jpg);height:602px"
      >
        <div class="content">
          <div class="container text-align-center">
            <div class="title font-color-1">金创客优势</div>
            <div class="font-color-1 sub-title">PREPONDERANCE</div>
            <div style="margin-bottom:34px;">
              <span class="slider slider-white"></span>
            </div>
            <div class="row">
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon1"></span>
                </div>
                <p class="p-title">优势一</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>核定征收</p>
                  <p>仅0.25% - 3.5%</p>
                </div>
              </div>
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon2"></span>
                </div>
                <p class="p-title">优势二</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>一站式财务代办</p>
                </div>
              </div>
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon3"></span>
                </div>
                <p class="p-title">优势三</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>解决利润</p>
                  <p>虚高、无进项</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon4"></span>
                </div>
                <p class="p-title">优势四</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>政策稳定</p>
                </div>
              </div>
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon5"></span>
                </div>
                <p class="p-title">优势五</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>专业服务团队</p>
                </div>
              </div>
              <div class="list-item">
                <div class="list-item-circle">
                  <span class="item-icon item-icon6"></span>
                </div>
                <p class="p-title">优势六</p>
                <div class="line">
                  <span class="split-line"></span>
                </div>
                <div>
                  <p>系统化税务</p>
                  <p>风险预防机制</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例分享 -->
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/education/education9.jpg);height:854px"
      >
        <div class="content">
          <div class="container">
            <div class="title font-color-2 text-align-center">案例分享</div>
            <div class="sub-title text-align-center">Case sharing</div>
            <div style="margin-bottom:50px;" class="text-align-center">
              <span class="slider slider-orange"></span>
            </div>
            <div class="row" style="flex-wrap: nowrap;align-items: center;">
              <img
                src="https://file.lgbfss.com/www/official/images/outsource/outsource4.jpg"
                alt
                style="flex-shrink:0;"
              />
              <div class="info">
                <p>小李是一名平面设计师，因业余爱好摄影摄像，其作品在社交媒体上深受广大网友的喜爱，也有不少影视传媒公司多次联系小李，希望让他承接一些企业的外包业务。但小李承接外包业务事常会遇到业务量不稳定、挂靠其他公司薪酬无法及时收取、税款缴纳不清晰等问题，一边要做业务，一边要管财务，对于“技术宅”的他头疼不已。</p>
                <p>小李在朋友的推荐下接触到“全球云端”零工创客共享服务平台，并顺利在平台上注册成立了个人独立工作室，平台提供商事登记、银行开户、税务申报、代理记账、代开发票等一站式财税服务，同时，可以享受园区核定征收的政策，综合税费在3%左右。小李把更多的精力放在业务和提供专业技能上，获得感也是十足！</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nav></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/nav";
import Footer from "../components/footer";
export default {
  name: "out_source",
  components: {
    Nav,
    Footer,
  },
};
</script>

<style lang="css" scoped>
.font-size-76 {
  font-size: 76px;
}
.text-align-center {
  text-align: center;
}
.register-btn {
  padding: 10px 40px;
  background-color: #fff;
  color: #444444;
  font-size: 35px;
  border-radius: 35px;
}
.title {
  font-size: 36px;
  font-weight: bold;
  padding: 34px 0 10px 0px;
}
.sub-title {
  font-size: 20px;
  color: #cbcbcb;
  font-family: Arial, Helvetica, sans-serif;
}
.content {
  color: #333333;
  padding: 5px 0;
}
.slider {
  display: inline-block;
  width: 80px;
  height: 3px;
}
.slider-orange {
  background-color: #f38303;
}
.slider-white {
  background-color: #ffffff;
}
.image-center {
  padding: 38px 0 58px 0;
}
.row {
  justify-content: center;
}
.list-item {
  background-color: #ffffff;
  margin: 6px;
  color: #333333;
  font-size: 20px;
  cursor: pointer;
  padding: 12px 0 14px 0;
  flex: 0%;
}
.list-item:hover {
  background-color: #64cdff;
  color: #ffffff;
}
.list-item .list-item-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #4c4c4c;
  margin: 0 auto;
}
.list-item:hover .list-item-circle {
  background-color: #fff;
}
.split-line {
  display: inline-block;
  width: 34px;
  height: 2px;
  background-color: #333333;
}
.list-item:hover .split-line {
  background-color: #ffffff;
}
.line {
  margin-top: -10px;
}
.item-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-top: 14px;
}
.list-item p {
  font-size: 15px;
}
.list-item p.p-title {
  font-size: 17px;
  margin-top: 10px;
}
.list-item > div > p {
  line-height: 22px;
}
.item-icon1 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon1.svg");
}
.item-icon2 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon2.svg");
}
.item-icon3 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon3.svg");
}
.item-icon4 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon4.svg");
}
.item-icon5 {
  height: 22px;
  margin-top: 18px;
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon5.svg");
}
.item-icon6 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon6.svg");
}
.list-item:hover .item-icon1 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon1-1.svg");
}
.list-item:hover .item-icon2 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon2-1.svg");
}
.list-item:hover .item-icon3 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon3-1.svg");
}
.list-item:hover .item-icon4 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon4-1.svg");
}
.list-item:hover .item-icon5 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon5-1.svg");
}
.list-item:hover .item-icon6 {
  background-image: url("https://file.lgbfss.com/www/official/images/outsource/icon6-1.svg");
}
.info {
  flex-grow: 1;
  padding: 20px 30px;
  box-shadow: 0 0 10px 2px #dbdbdb;
}
.info p {
  font-size: 16px;
  color: #666666;
  line-height: 32px;
  margin-bottom: 50px;
}
.info p:last-child {
  margin-bottom: 0;
}
</style>
